export default __webpack_public_path__ + "static/media/guiaAndroid1.b2e9d258.png";